import { Link, Typography } from "@mui/material";
import { typedLocalize } from "@smartrr/shared/utils/sharedTranslations/localize";
import React from "react";

export const NoSubscriptions = () => {
  return (
    <React.Fragment>
      <span className="anchor" id="subscriptions" />
      <Typography variant="h2">{typedLocalize("subscriptions.title")}</Typography>
      <Typography variant="body1">
        {typedLocalize("subscriptions.zeroState")}{" "}
        <Link href={typedLocalize("general.startShoppingLink")} underline="always" sx={{ color: "inherit" }}>
          {typedLocalize("general.startShopping")}
        </Link>
      </Typography>
    </React.Fragment>
  );
};
